export const WebAppPaths = {
  leadLanding: '/source',
  start: '/start',
};

export const YouSetDomains = {
  webPage: 'https://www.youset.ca',
};

export const YouSetWebpageLinks = {
  en: {
    blog: 'https://youset.ca/en/blog/',
    claims: 'https://youset.ca/en/claims/',
    careers: 'https://youset.ca/en/careers/',
    disclosure: 'https://youset.ca/en/disclosure-letter/',
    faq: 'https://youset.ca/en/faq',
    privacyPolicy: 'https://youset.ca/en/privacy-policy',
    termsOfUse: 'https://youset.ca/en/terms-of-use',
    helpCenter: 'https://youset.ca/en/help-center/',
    contactUs: 'https://youset.ca/en/contact-us/',
  },
  fr: {
    blog: 'https://youset.ca/fr/blog/',
    careers: 'https://youset.ca/fr/carrieres/',
    claims: 'https://youset.ca/fr/reclamations/',
    disclosure: 'https://youset.ca/fr/lettre-de-divulgation/',
    faq: 'https://youset.ca/fr/questions',
    privacyPolicy: 'https://youset.ca/fr/politique-de-confidentialite',
    termsOfUse: ' https://youset.ca/fr/conditions-utilisation',
    helpCenter: 'https://youset.ca/fr/centre-daide/',
    contactUs: 'https://youset.ca/fr/nous-joindre/',
  },
};
